<div
  class={`variation-row move-list-row ${bgColorClass}`}
>
  <div
    class='variation-row-indent'
  >
    {#each indentations as { trimTop, trimBottom }}
      <div
        class='vertical-line'
        class:trim-top={trimTop}
        class:trim-bottom={trimBottom}
      />
    {/each}
  </div>
  <div class='variation-content'>
    <VariationLine
      moveListNodes={$moveListRow.content}
    />
  </div>
</div>

<svelte:options immutable/>

<script lang="ts">
import type { MoveListComponent } from 'components/move-list/config/types';
import type { Data } from 'src/utils/svelte/data';
import VariationLine from 'components/move-list/components/variations/variation-line.svelte';

export let moveListRow: Data<MoveListComponent.Row<MoveListComponent.MoveListNode[]>>;
export let nextMoveListRow: Data<MoveListComponent.Row> | undefined;

$: bgColorClass = $moveListRow.rowBgColor ?? 'light-row';
$: indentations = getIndentations($moveListRow.depth, $nextMoveListRow?.depth ?? 0);

/**
 * determines if the indentation divider should be trimmed at the top
 */
function shouldTrimIndentTop(indentationDepth: number, rowDepth: number): boolean {
  const isLastIndent = indentationDepth === rowDepth;
  return isLastIndent;
}

/**
 * determines if the indentation divider should be trimmed at the bottom
 */
function shouldTrimIndentBottom(
  indentationDepth: number,
  rowDepth: number,
  followingRowDepth: number,
): boolean {
  const nextRowIsNotChild = followingRowDepth <= rowDepth;
  const indentIsBeyondNextRowIndent = indentationDepth >= followingRowDepth;
  return nextRowIsNotChild && indentIsBeyondNextRowIndent;
}

type Indentation = {
  trimTop: boolean;
  trimBottom: boolean;
};

/**
 * Gets the indentation dividers for the row
 */
function getIndentations(rowDepth: number, followingRowDepth: number): Indentation[] {
  const indents: Indentation[] = [];

  for (let i = 0; i < rowDepth; i++) {
    indents.push({
      trimTop: shouldTrimIndentTop(i + 1, rowDepth),
      trimBottom: shouldTrimIndentBottom(i + 1, rowDepth, followingRowDepth),
    });
  }

  return indents;
}
</script>
